import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChevronRight = () => {
  return (
    <g>
      <path d="m4.98 14.79a.75.75 0 0 1 -.53-1.28l5.5095-5.51-5.5095-5.51a.75.75 0 0 1 1.06-1.06l6.04 6.04a.75.75 0 0 1 0 1.0605l-6.04 6.0395a.7467.7467 0 0 1 -.53.22z" />
    </g>
  );
};

export default withIcon(IconChevronRight);
